import { AdditionalInformationParsed } from './../../apps/shoppingCart/interfaces/configuration';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ModuleInformation } from './../../models/module-information';
import { RecordListDrawerArgs } from 'src/app/models/record-list-drawer-args';
import { Field, FieldDataType, Values } from './../../models/module-structure';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ComponentRef,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { LayoutService } from '../layout.service';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { ModuleStructure } from 'src/app/models/module-structure';
import { Action, RecordModel } from '../record-model';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordPageComponent } from '../record-page/record-page.component';
import {
  SectionTableFilter,
  SectionTableFilterTypes,
} from 'src/app/models/section-table-filter';
import { RecordListCustomDataParam } from 'src/app/models/record-list-custom-data-param';
import { ModuleFilter } from 'src/app/models/module-filter';
import * as g from '../../globals';
import { RecordsListTableComponent } from '../records-list-table/records-list-table.component';
@Component({
  selector: 'app-records-list',
  templateUrl: './records-list.component.html',
  styleUrls: ['./records-list.component.less'],
})
export class RecordsListComponent implements OnInit, OnDestroy {
  FieldDataType = FieldDataType;
  private componentRef: ComponentRef<any>;
  moduleActions: Action[];
  showDraftButton: boolean;
  allowExportToExcel: boolean;
  isCustomAccess: boolean;
  customCondition = '';
  customTitleSuffix = '';
  sortablFields: any[];

  filterFields: any[];

  @Output() filtersChange = new EventEmitter<{
    [key: string]: SectionTableFilter;
  }>();

  constructor(
    public layoutService: LayoutService,
    public router: Router,
    public route: ActivatedRoute,
    private drawerService: NzDrawerService,
    private messageService: NzMessageService
  ) {}

  global = g;
  isError = false;
  errorMessage = '';

  isInitialized = false;
  moduleIdVar = 0;
  contextMenuItems: Array<{ menuText: string; menuEvent: string }> = [
    {
      menuText: 'Duplicate',
      menuEvent: 'Duplicate',
    },
  ];
  rightClickMenuPositionX = 0;
  rightClickMenuPositionY = 0;
  isDisplayContextMenu = false;
  moduleFilter: ModuleFilter;
  moduleFilterIdVal = 0;
  @Input() set moduleFilterId(value: number) {
    if (this.moduleFilterIdVal !== value) {
      this.moduleFilterIdVal = value;
      if (
        this.moduleFilterIdVal === undefined ||
        this.moduleFilterIdVal == null ||
        Number(this.moduleFilterIdVal) === 0
      ) {
        this.moduleFilter = undefined;
        this.pageTitle = undefined;
        this.icon = undefined;
      } else {
        this.layoutService
          .getFilterInfo(this.moduleFilterIdVal)
          .subscribe((d: ModuleFilter) => {
            this.moduleFilter = d;

            this.pageTitle =
              this.moduleFilter.AdditionalInformationParsed.Label;
            this.icon = this.moduleFilter.AdditionalInformationParsed.Icon;
          });
      }
      if (this.isInitialized) {
        this.setModuleId();
      }
    }
  }

  get moduleFilterId() {
    return this.moduleFilterIdVal;
  }

  @Input() set moduleId(value: number) {
    if (this.moduleIdVar !== value) {
      if (!this.isKanban) {
        this.isLoading = true;
        this.moduleIdVar = value;
        this.moduleStructure = undefined;
        this.moduleInformation = undefined;
        this.fields = undefined;
        this.listOfRecords = undefined;
      }

      this.moduleIdVar = value;
      this.term = '';
      if (this.isInitialized) {
        this.setModuleId();
      }
    }
  }

  get moduleId() {
    return this.moduleIdVar;
  }
  fromDraftValue = false;
  @Input() set fromDraft(value: boolean) {
    this.fromDraftValue = value;
    this.reloadTheRecords();
  }
  get fromDraft() {
    return this.fromDraftValue;
  }
  @Input() moduleStructure: ModuleStructure;
  @Input() moduleInformation: ModuleInformation;
  @Input() isEditable = false;
  @Input() isKanban = false;
  @Input() createNewLink: string | any;
  @Input() displayBackIcon = false;
  @Input() displayHeader = true;
  @Input() pageSubtitle: string;
  @Input() pageTitle: string;
  @Input() icon: string;
  @Input() inDrawer = false;
  @Input() isSinglSelection = true;
  @Input() isSelection = false;
  @Input() linkedFieldId = 0;
  @Input() lineId = 0;
  @Input() linkedFieldSectionTagName = '';
  @Input() recordModel: RecordModel;
  @Input() term = '';
  @Input() displayNewButton = true;
  @Input() selectedRecords: string[] = [];
  @Input() selectedRecordsFromCheckBox: string[] = [];
  @Input() showCheckBoxInTableMode = false;
  @Input() customData = false;
  @Input() customActions: { label: string; key: string }[];
  @Input() keyName = 'KEY';
  @Input() autoFocusOnSearch = true;
  @Input() searchVisible = true;
  @Input() displaySearchButton = false;
  @Input() hidePaginationOnSinglePage = false;
  @Input() displayLabels = true;
  @Input() inputValuesForNew: Values = {};
  @Input() takeIdFromLink = true;
  @Input() newRecordInDrawer = true;
  @Input() inModuleList = false;
  @Output() newRecordClicked = new EventEmitter();
  @Output() backButtonClicked = new EventEmitter();
  @Output() selectionChanged = new EventEmitter<string[]>();
  @Output() selectRecordFromCheckBoxChanged = new EventEmitter<string[]>();
  @Output() newObjectCreated = new EventEmitter<string>();
  @Output() loadCustomData = new EventEmitter<RecordListCustomDataParam>();

  @Output() customActionClicked = new EventEmitter<{
    key: string;
    value: any;
  }>();
  filtersValue: { [key: string]: SectionTableFilter };
  @Input() set filters(value: { [key: string]: SectionTableFilter }) {
    this.filtersValue = value;
    if (!this.isLoading) {
      this.reloadTheRecords();
    }
  }

  get filters() {
    return this.filtersValue;
  }

  valuesToPass: { Key: string; Value: string }[];
  newRecDrawerVisible = false;
  isLoading = true;
  isLoadingData = true;
  exporting = false;
  fields: any[];
  listOfRecords: any;
  @Input() displayMode = 'table';
  @Input() forceDisplayModeFromInput = false;
  screenSize: string;
  sortedByDir: string;
  sortedByField: number;
  sortedByName: string;
  pageIndex = 1;
  pageSize = 20;
  totalRecords = 0;

  secondaryFieldId = '';
  showFilterDrawer = false;
  allowBulkEdit = false;

  submitCreateButtonEmitter = new EventEmitter<NzButtonComponent>();
  @ViewChild('searchField') searchField: ElementRef;
  static openRecordListDrawer(
    drawerService: NzDrawerService,
    args: RecordListDrawerArgs
  ) {
    const drawerRef = drawerService.create<RecordsListComponent>({
      nzTitle: 'List',
      nzWrapClassName: 'drawer-size-4x drawer-body-no-padding',
      nzContent: RecordsListComponent,
      nzContentParams: {
        moduleId: args.moduleId,
        inDrawer: args.inDrawer,
        isSinglSelection: args.isSingleSelection,
        linkedFieldId: args.linkedFieldId,
        linkedFieldSectionTagName: args.linkedFieldSectionTagName,
        term: args.term,
        lineId: args.lineId,
        recordModel: args.recordModel,
        filters: args.filters,
        showCheckBoxInTableMode: args.showCheckBoxInTableMode,
        moduleFilterId: args.moduleFilterId,
      },
    });

    drawerRef.afterOpen.subscribe(() => {
      const recordsListComponent = drawerRef.getContentComponent();
      recordsListComponent.backButtonClicked.subscribe(() => {
        //console.log(args.recordModel.ThereIsChange);
        drawerRef.close();
      });
      recordsListComponent.selectionChanged.subscribe(($event) => {
        if (args.customActionCode != null) {
          args.parentComponent.selectionChanged($event, args.customActionCode);
        } else {
          args.parentComponent.selectionChanged($event);
        }
      });
      recordsListComponent.newObjectCreated.subscribe(($event) => {
        if (args.customActionCode != null) {
          args.parentComponent.submitSelection($event, args.customActionCode);
          drawerRef.close();
        } else {
          args.parentComponent.submitSelection($event);
        }
      });
    });

    drawerRef.afterClose.subscribe(() => {
      drawerRef.getContentComponent().destroy();
    });
  }

  destroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  ngOnDestroy(): void {
    console.log('💨 Record list destroyed!');
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }
  }

  ngOnInit(): void {
    // this.router.events.subscribe((data) => {
    //   if (data instanceof NavigationEnd) {
    //     this.term = '';
    //     this.reloadTheRecords();
    //   }
    // });

    this.allowBulkEdit = this.global.allowBulkEdit;

    this.layoutService
      .getConfiguration('config_recordsList_default_view')
      .subscribe((data) => {
        if (!this.forceDisplayModeFromInput) {
          if (data && data !== '') {
            this.displayMode = data as string;
          } else {
            this.displayMode = 'table';
          }

          this.displayMode = this.getValueFromLocalStorage(
            `displayMode[${this.moduleId}]`,
            this.displayMode
          );
        }
        if (this.global.forceDisplayModeAsTable) {
          this.displayMode = 'table';
        }
      });
    this.screenSize = this.layoutService.screenSize;

    this.route.params.subscribe((params) => {
      if (params === undefined || this.isKanban) {
        // this.initializeList();
        return;
      }

      if (
        params.selectedId !== undefined &&
        params.selectedId !== null &&
        this.takeIdFromLink
      ) {
        if (
          this.selectedRecords !== undefined ||
          this.selectedRecords.indexOf(params.selectedId) === -1
        ) {
          if (
            this.selectedRecords.length === 1 &&
            this.selectedRecords[0] === params.selectedId
          ) {
            return;
          } else {
            this.selectedRecords = [];
            this.selectedRecords.push(params.selectedId);
            this.selectionChanged.emit(this.selectedRecords);
          }
        }
      }
    });

    this.layoutService.screenSizeEmitter.subscribe((size) => {
      this.screenSize = size;
    });

    this.layoutService.refreshListEmitter.subscribe((size) => {
      this.term = '';
      this.reloadTheRecords();
      this.selectedRecords = [];
      this.selectedRecordsFromCheckBox = [];
      this.selectionChanged.emit(this.selectedRecords);
      this.selectRecordFromCheckBoxChanged.emit(
        this.selectedRecordsFromCheckBox
      );
    });

    this.setModuleId(true);

    console.log('isEditable', this.isEditable);
  }

  getOptions(field: import('src/app/models/module-structure').Field) {
    let queryId = field.SQLStatementId;
    if (
      field.FilterSQLStatementId != null &&
      field.FilterSQLStatementId !== 0
    ) {
      queryId = field.FilterSQLStatementId;
    }

    // const paramsNames = g.queriesData[queryId];
    // const vals: string[] = [];

    this.layoutService
      .getSelectValues(
        this.moduleStructure,
        field.AdditionalInformationParsed.DataSourcePath,
        field.Id,
        queryId,
        [],
        []
      )
      .subscribe((d: any) => {
        field.Options = d.Values.rowsArray;
      });
  }

  updateFilter(): void {
    this.reloadTheRecords();
  }

  keyup($event: any) {
    if ($event.key === 'Enter' || $event.key === 'Tab') {
      this.updateFilter();
    }
  }

  getNextRecord(currentRecord) {
    let index = 0;
    for (const record of this.listOfRecords.table.rowsArray) {
      if (record[this.keyName].toString() === currentRecord.toString()) {
        const recordToMoveTo = this.listOfRecords.table.rowsArray[index - 1];
        if (recordToMoveTo === undefined) {
          this.messageService.info(
            this.layoutService.translate(
              'You have reached the end of the record set.'
            )
          );
          return undefined;
        }

        return [recordToMoveTo[this.keyName]];
      } else {
        index++;
      }
    }
  }

  getPrevRecord(currentRecord) {
    let index = 0;
    for (const record of this.listOfRecords.table.rowsArray) {
      if (record[this.keyName].toString() === currentRecord.toString()) {
        const recordToMoveTo = this.listOfRecords.table.rowsArray[index + 1];
        if (recordToMoveTo === undefined) {
          this.messageService.info(
            this.layoutService.translate(
              'You have reached the beginning of the record set.'
            )
          );
          return undefined;
        }

        return [recordToMoveTo[this.keyName]];
      } else {
        index++;
      }
    }
  }

  setModuleId(onLoading: boolean = false) {
    if (
      this.moduleInformation === undefined ||
      this.moduleInformation.ModuleId.toString() !== this.moduleId.toString()
    ) {
      if (this.moduleId == null) {
        this.moduleActions = [];
      } else {
        this.layoutService
          .getActions(this.moduleId)
          .subscribe((d: Action[]) => {
            this.moduleActions = d;
          });
      }

      this.layoutService
        .moduleInformation(this.moduleId.toString())
        .subscribe((d: ModuleInformation) => {
          this.isInitialized = true;
          this.moduleInformation = d;
          this.moduleInformation.ModuleId = this.moduleId;
          this.AfterSetModuleId(onLoading);
        });
    } else {
      this.AfterSetModuleId(onLoading);
    }
  }

  private reloadInterval: any = null;
  private isReloading = false;
  private startReloadInterval(onLoading: boolean) {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
    }

    const intervalInMinutes = g.autoRefreshListIntervalInMinutes;
    this.reloadInterval = setInterval(async () => {
      if (this.isReloading) return;
      this.isReloading = true;

      try {
        await this.reloadTheRecords(onLoading);
      } finally {
        this.isReloading = false;
      }
    }, intervalInMinutes * 60 * 1000);
  }

  private AfterSetModuleId(onLoading: boolean = false) {
    if (!this.forceDisplayModeFromInput) {
      this.displayMode = this.getValueFromLocalStorage(
        `displayMode[${this.moduleId}]`,
        'table'
      );
    }

    if (this.global.forceDisplayModeAsTable) {
      this.displayMode = 'table';
    }

    this.sortedByDir = this.getValueFromLocalStorage(
      `sortedByDir[${this.moduleId}]`,
      ''
    );
    this.sortedByField = Number(
      this.getValueFromLocalStorage(`sortedByField[${this.moduleId}]`, '0')
    );
    this.pageSize = Number(
      this.getValueFromLocalStorage(`pageSize[${this.moduleId}]`, '20')
    );
    if (this.moduleStructure != null) {
      this.showDraftButton =
        this.moduleStructure.module.AdditionalInformationParsed.AllowSaveToDraft;
      this.allowExportToExcel =
        this.moduleStructure.module.AdditionalInformationParsed.AllowExportToExcel;
    }

    if (this.linkedFieldId != null && this.linkedFieldId !== 0) {
      this.layoutService
        .getFieldDetails(this.linkedFieldId)
        .subscribe((f: Field) => {
          this.valuesToPass = Field.getValuesToPassBasedOnConditions(
            f,
            this.recordModel,
            this.lineId,
            this.linkedFieldSectionTagName
          );
          if (
            !this.isKanban &&
            (this.moduleStructure === undefined ||
              !this.moduleStructure.hasOwnProperty('module'))
          ) {
            this.initializeList(onLoading);
          }
        });
    } else {
      if (
        !this.isKanban &&
        (this.moduleStructure === undefined ||
          this.moduleStructure.hasOwnProperty('module'))
      ) {
        this.initializeList(onLoading);
      } else if (this.isKanban) {
        this.layoutInit(onLoading);
      }
    }

    if (this.linkedFieldId != null && this.linkedFieldId !== 0) {
      this.layoutService
        .getFieldDetails(this.linkedFieldId)
        .subscribe((f: Field) => {
          this.valuesToPass = Field.getValuesToPassBasedOnConditions(
            f,
            this.recordModel,
            this.lineId,
            this.linkedFieldSectionTagName
          );
          if (
            !this.isKanban &&
            (this.moduleStructure === undefined ||
              !this.moduleStructure.hasOwnProperty('module'))
          ) {
            this.initializeList(onLoading);
          }
        });
    } else {
      if (
        !this.isKanban &&
        (this.moduleStructure === undefined ||
          this.moduleStructure.hasOwnProperty('module'))
      ) {
        this.initializeList(onLoading);
      } else if (this.isKanban) {
        this.layoutInit(onLoading);
      }
    }

    var modulesToCheck = g.autoRefreshListForModules.split(',');
    if (modulesToCheck.indexOf(this.moduleId.toString()) !== -1) {
      this.startReloadInterval(onLoading);
    }
  }

  showDrafts() {
    // let url = '';
    // switch (g.userIdentity.Area) {
    //   case 1:
    //     url = '/apps/crm/module-list/';
    //     break;
    //   case 2:
    //     url = '/apps/external-portal/app-container/10/module-list/';
    //     break;
    //   case 3:
    //     url = '/apps/external-portal/app-container/9/module-list/';
    //     break;
    //   default:
    //     break;
    // }

    this.layoutService.getActions(this.moduleId).subscribe((d: Action[]) => {
      this.moduleActions = d;
    });

    this.router.navigate(['.', { fromDraft: !this.fromDraft }], {
      relativeTo: this.route,
    });
    // this.router.navigate(['../../59'], {
    //   queryParams: {
    //     fromDraft: true,
    //     objectKey: this.moduleStructure.module.ObjectTypeValue
    //   }, queryParamsHandling: 'merge',
    //   relativeTo: this.route
    // });
  }

  initializeList(onLoading: boolean = false) {
    this.layoutService
      .getModuleStructure(this.moduleId)
      .subscribe((m: ModuleStructure) => {
        this.moduleStructure = m;
        this.showDraftButton =
          this.moduleStructure.module.AdditionalInformationParsed.AllowSaveToDraft;
        this.allowExportToExcel =
          this.moduleStructure.module.AdditionalInformationParsed.AllowExportToExcel;
        this.isCustomAccess =
          this.moduleStructure.module.AdditionalInformationParsed
            .CustomConditionSectionId != null &&
          this.moduleStructure.module.AdditionalInformationParsed
            .CustomConditionSectionId !== undefined &&
          this.moduleStructure.module.AdditionalInformationParsed
            .CustomConditionSectionId != 0;
        let customConditionInfoKeysLabel =
          this.moduleStructure.module.AdditionalInformationParsed
            .CustomConditionInfoKeysLabel == null ||
          this.moduleStructure.module.AdditionalInformationParsed
            .CustomConditionInfoKeysLabel === undefined
            ? []
            : this.moduleStructure.module.AdditionalInformationParsed.CustomConditionInfoKeysLabel.split(
                ','
              );
        this.customCondition = '';
        this.customTitleSuffix = '';
        if (
          this.global.userIdentity.CustomCondition != null &&
          this.global.userIdentity.CustomCondition !== undefined
        ) {
          this.customCondition =
            this.global.userIdentity.CustomCondition[this.moduleId];

          if (
            this.customCondition != null &&
            this.customCondition !== undefined &&
            this.customCondition !== ''
          ) {
            let customConditionObj = JSON.parse(this.customCondition);
            customConditionInfoKeysLabel.forEach((element) => {
              this.customTitleSuffix +=
                element + ':' + customConditionObj[element] + ' ,';
            });
            this.customTitleSuffix = this.customTitleSuffix.substring(
              0,
              this.customTitleSuffix.lastIndexOf(' ,')
            );
          }
        }
        this.layoutService
          .getListStructure(this.moduleId)
          .subscribe(
            (d: {
              fields: any[];
              sortedByField: number;
              sortedByDir: string;
            }) => {
              this.fields = d.fields?.filter(
                (f) => f.AdditionalInformationParsed.VisibleInTableList
              );
              const inVisibleFilters = this.fields?.filter(
                (f) => !f.AdditionalInformationParsed.VisibleInTableList
              );

              inVisibleFilters?.forEach((f) => {
                this.fields.push(f);
              });
              //console.log(this.fields);

              const field = this.fields.find(
                (f) => f.AdditionalInformationParsed.SecondaryId
              );
              if (field !== undefined) {
                this.secondaryFieldId = field.FieldName;
              }

              this.sortablFields = this.fields.filter(
                (x) =>
                  x.DataType != 7 &&
                  x.AdditionalInformationParsed.VisibleInTableList
              );

              if (this.filtersValue === undefined) {
                this.filtersValue = {};
              }
              for (const field of this.fields) {
                if (field.AdditionalInformationParsed.VisibleInTableList) {
                  if (this.filtersValue[field.PropertyName] === undefined) {
                    this.filtersValue[field.PropertyName] = {
                      valueFrom: null,
                      valueTo: null,
                      singleValue: null,
                      filterType: SectionTableFilterTypes.fromProperty,
                    };
                  }
                }
              }

              if (this.sortedByDir === '' || this.sortedByDir === 'undefined') {
                this.sortedByDir = d.sortedByDir;
              }

              if (
                this.sortedByField === 0 ||
                this.sortedByField < 0 ||
                this.sortedByField > this.fields.length
              ) {
                this.sortedByField = Number(d.sortedByField);
              }

              if (isNaN(this.sortedByField)) {
                this.sortedByField = 1;
              }

              this.sortedByName = this.fields[this.sortedByField - 1].Label;
              this.reloadTheRecords(onLoading);
            }
          );
      });
  }

  layoutInit(onLoading: boolean = false) {
    this.layoutService
      .getListStructure(this.moduleId)
      .subscribe(
        (d: { fields: any[]; sortedByField: number; sortedByDir: string }) => {
          this.fields = d.fields;

          for (const field of this.fields) {
            if (field.AdditionalInformationParsed.VisibleInTableList) {
              if (this.filtersValue[field.PropertyName] === undefined) {
                this.filtersValue[field.PropertyName] = {
                  valueFrom: null,
                  valueTo: null,
                  singleValue: null,
                  filterType: SectionTableFilterTypes.fromProperty,
                };
              }
            }
          }

          if (this.sortedByDir === '') {
            this.sortedByDir = d.sortedByDir;
          }

          if (
            this.sortedByField === 0 ||
            this.sortedByField < 0 ||
            this.sortedByField > this.fields.length
          ) {
            this.sortedByField = Number(d.sortedByField);
          }

          if (isNaN(this.sortedByField)) {
            this.sortedByField = 1;
          }

          this.sortedByName = this.fields[this.sortedByField - 1].Label;
          this.reloadTheRecords();
        }
      );
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params;
    const currentSort = sort.find((item) => item.value !== null);
    const sortField = (currentSort && currentSort.key) || null;
    const sortOrder = (currentSort && currentSort.value) || null;

    this.reloadTheRecords();
  }

  paginationChanged(sender: any): void {
    this.pageIndex = sender.nzPageIndex;
    this.pageSize = sender.nzPageSize;

    this.reloadTheRecords();
  }

  reloadTheRecords(
    onLoading: boolean = false,
    resetFilters: boolean = false
  ): void {
    if (this.fields == null || this.fields === undefined) {
      return;
    }

    const sortedByFieldName = this.fields[this.sortedByField - 1].FieldName;

    this.isLoadingData = true;
    if (this.customData) {
      this.loadCustomData.emit({
        moduleId: this.moduleId,
        moduleFilterId: this.moduleFilterId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortedByFieldName,
        sortedByDir: this.sortedByDir,
        term: this.term,
        linkedFieldId: this.linkedFieldId,
        valuesToPass: this.valuesToPass,
        filters: this.filters,
      });
    } else {
      if (resetFilters) {
        for (const field of this.fields) {
          if (field.AdditionalInformationParsed.VisibleInTableList) {
            if (this.filtersValue[field.PropertyName] === undefined) {
              this.filtersValue[field.PropertyName] = {
                valueFrom: null,
                valueTo: null,
                singleValue: null,
                filterType: SectionTableFilterTypes.fromProperty,
              };
            } else {
              this.filtersValue[field.PropertyName].valueFrom = null;
              this.filtersValue[field.PropertyName].valueTo = null;
              this.filtersValue[field.PropertyName].singleValue = null;
            }
          }
        }
        this.valuesToPass = [];
        this.term = '';
      }
      this.layoutService
        .getListOfRecords(
          this.moduleId,
          this.moduleFilterId,
          this.pageIndex,
          this.pageSize,
          sortedByFieldName,
          this.sortedByDir,
          this.term,
          this.linkedFieldId,
          this.valuesToPass,
          this.filters,
          this.fromDraft
        )
        .subscribe((d: any) => {
          if (d.IsError) {
            this.isError = true;
            this.errorMessage = d.ErrorMessage;
          } else {
            this.isError = false;
            this.errorMessage = '';
          }
          this.listOfRecords = d;
          this.totalRecords = d.table.length;
          if (this.secondaryFieldId !== '') {
            for (
              let index = 0;
              index < this.listOfRecords.table.rowsArray.length;
              index++
            ) {
              const line = this.listOfRecords.table.rowsArray[index];
              line['KEY'] = line['KEY'] + '~' + line[this.secondaryFieldId];
            }
          }
          this.isLoading = this.isLoadingData = false;
          if (onLoading) {
            setTimeout(() => {
              if (this.autoFocusOnSearch && this.searchField != null) {
                this.searchField.nativeElement.focus();
              }
            }, 300);
          }

          localStorage.setItem(
            `displayMode[${this.moduleId}]`,
            this.displayMode
          );
          localStorage.setItem(
            `sortedByDir[${this.moduleId}]`,
            this.sortedByDir
          );
          localStorage.setItem(
            `sortedByField[${this.moduleId}]`,
            this.sortedByField.toString()
          );
          localStorage.setItem(
            `pageSize[${this.moduleId}]`,
            this.pageSize.toString()
          );

          if (
            this.totalRecords == 1 &&
            this.moduleStructure.module.AdditionalInformationParsed
              .NavigateToRecordDirectly
          ) {
            this.selectRecord(this.listOfRecords.table.rowsArray[0]);
          }
        });
    }

    this.selectedItemsForBulkEdit = [];
  }

  exportTheRecords(exportType = 'excel'): void {
    if (this.fields == null || this.fields === undefined) {
      return;
    }

    const sortedByFieldName = this.fields[this.sortedByField - 1].FieldName;

    this.exporting = true;

    this.layoutService
      .exportTheRecords(
        this.moduleId,
        this.moduleFilterId,
        this.pageIndex,
        this.pageSize,
        sortedByFieldName,
        this.sortedByDir,
        this.term,
        this.linkedFieldId,
        this.valuesToPass,
        this.filters,
        this.fromDraft,
        exportType
      )
      .subscribe(
        (data: { IsError: boolean; Message: string; FileContent: string }) => {
          if (data.IsError) {
            this.messageService.error(data.Message);
          } else {
            this.downloadFile(data.FileContent, exportType);
          }
          this.exporting = false;
        }
      );
  }

  customConditionOkButtonClicked() {
    console.log('Filter button clicked:', this.filterFields);
    let filterFieldsVal: any[];
    if (
      this.filterFields != null &&
      this.filterFields !== undefined &&
      this.filterFields['filterFields'] != null &&
      this.filterFields['filterFields'] !== undefined
    ) {
      filterFieldsVal = this.filterFields['filterFields'];
    } else {
      filterFieldsVal = this.filterFields;
    }

    let condition: { Key: string; Value: string }[] = [];
    filterFieldsVal.forEach((field) => {
      condition.push({
        Key: field.FieldName,
        Value: field.Value,
      });
    });

    this.layoutService
      .setCustomConditionForModule(this.moduleId, JSON.stringify(condition))
      .subscribe((data: { Has_Error: boolean; Error_Message: string }) => {
        if (data.Has_Error) {
          this.messageService.error(data.Error_Message);
        } else {
          if (this.global.userIdentity.CustomCondition == null) {
            this.global.userIdentity.CustomCondition = [];
          }

          let conditionToSave: { [key: string]: any } = {};
          filterFieldsVal.forEach((field) => {
            conditionToSave[field.FieldName] = field.Value;
          });

          this.global.userIdentity.CustomCondition[this.moduleId] =
            JSON.stringify(conditionToSave);

          this.customCondition = JSON.stringify(conditionToSave);

          let customConditionInfoKeysLabel =
            this.moduleStructure.module.AdditionalInformationParsed
              .CustomConditionInfoKeysLabel == null ||
            this.moduleStructure.module.AdditionalInformationParsed
              .CustomConditionInfoKeysLabel === undefined
              ? []
              : this.moduleStructure.module.AdditionalInformationParsed.CustomConditionInfoKeysLabel.split(
                  ','
                );
          this.customTitleSuffix = '';
          if (
            this.global.userIdentity.CustomCondition != null &&
            this.global.userIdentity.CustomCondition !== undefined
          ) {
            customConditionInfoKeysLabel.forEach((element) => {
              this.customTitleSuffix +=
                element + ':' + conditionToSave[element] + ' ,';
            });
            this.customTitleSuffix = this.customTitleSuffix.substring(
              0,
              this.customTitleSuffix.lastIndexOf(' ,')
            );
          }

          this.reloadTheRecords();
        }
      });
  }

  resetCustomCondition() {
    this.layoutService
      .resetCustomCondition(this.moduleId)
      .subscribe((data: { Has_Error: boolean; Error_Message: string }) => {
        if (data.Has_Error) {
          this.messageService.error(data.Error_Message);
        } else {
          if (this.global.userIdentity.CustomCondition == null) {
            this.global.userIdentity.CustomCondition = [];
          }
          this.global.userIdentity.CustomCondition[this.moduleId] = '';

          this.customCondition = '';
          //this.reloadTheRecords();

          if (
            this.filterFields != null &&
            this.filterFields !== undefined &&
            this.filterFields['filterFields'] != null &&
            this.filterFields['filterFields'] !== undefined
          ) {
            this.filterFields['filterFields'].forEach((element) => {
              element.Value = '';
            });
          } else {
            this.filterFields.forEach((element) => {
              element.Value = '';
            });
          }
        }
      });
  }

  downloadFile(data: string, type: string) {
    let mimeType = '';
    let extension = '';
    if (type === 'excel') {
      mimeType = 'application/vnd.ms-excel';
      extension = 'xlsx';
    } else if (type === 'csv') {
      mimeType = 'text/csv';
      extension = 'csv';
    } else if (type === 'pdf') {
      mimeType = 'application/pdf';
      extension = 'pdf';
    }

    let dataToDownload: Blob;
    if (type === 'csv') {
      const blob = new Blob([data], {
        type: mimeType,
      });
      dataToDownload = blob;
    } else {
      const blob = new Blob([this.base64ToArray(data)], {
        type: mimeType,
      });
      dataToDownload = blob;
    }

    const url = window.URL.createObjectURL(dataToDownload);
    const anchor = document.createElement('a');
    anchor.download = `${this.moduleStructure.module.Name}.${extension}`;
    anchor.href = url;
    anchor.click();
    anchor.remove();
  }

  base64ToArray(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  changeDisplayMode(newValue: string) {
    this.displayMode = newValue;

    this.reloadTheRecords();
  }

  changeSortingMode(newValue: number) {
    if (this.sortedByField === newValue) {
      this.sortedByDir = this.sortedByDir === 'DESC' ? 'ASC' : 'DESC';
    } else {
      this.sortedByField = newValue;
    }

    this.reloadTheRecords();
  }

  getValueFromLocalStorage(key: string, defaultValue: any): string {
    let storedValue = localStorage.getItem(key);
    if (
      storedValue === undefined ||
      storedValue === null ||
      storedValue === ''
    ) {
      localStorage.setItem(key, defaultValue);
      storedValue = defaultValue;
    }

    return storedValue;
  }

  openDetails(keyVal: string) {
    this.router.navigate(['apps/subscription/create-customer'], {
      queryParams: { recordId: keyVal },
    });
  }

  pageHaderBack() {
    if (this.inDrawer) {
      this.backButtonClicked.emit();
    } else {
      this.backButtonClicked.emit();
    }
  }

  selectRecordFromCheckBox(event: { data: any; event: boolean }) {
    if (event.event) {
      this.selectedRecordsFromCheckBox.push(event.data[this.keyName]);
    } else {
      this.selectedRecordsFromCheckBox =
        this.selectedRecordsFromCheckBox.filter(
          (d) => d !== event.data[this.keyName]
        );
    }

    this.selectRecordFromCheckBoxChanged.emit(this.selectedRecordsFromCheckBox);
  }

  selectRecord(record) {
    if (this.selectedRecords === undefined) {
      this.selectedRecords = [];
    }

    if (record !== undefined) {
      const recordIndex = this.selectedRecords.indexOf(
        record[this.keyName].toString()
      );
      if (recordIndex === -1) {
        if (this.isSinglSelection) {
          this.selectedRecords = [record[this.keyName].toString()];
        } else {
          this.selectedRecords.push(record[this.keyName].toString());
        }
      } else {
        this.selectedRecords.splice(recordIndex, 1);
      }

      /*let baseUrl = this.router.url.split(';')[0];
      var indexOfModuleList = baseUrl.indexOf('module-list');
      baseUrl = baseUrl.substring(0, indexOfModuleList);
      baseUrl = `${baseUrl}/module-list/${this.moduleId}/0`;

      this.router.navigate([
        baseUrl,
        {
          fromDraft: false,
          newMode: true,
          actionType: 2,
          moduleActionType: 2,
          sourceObject: this.moduleId,
          sourceObjectId: record[this.keyName].toString(),
          customActionCode: '',
          inDrawer: false,
        },
      ]);*/
    } else {
      this.selectedRecords = [];
    }

    this.selectionChanged.emit(this.selectedRecords);
  }

  openNewRecDrawer() {
    if (this.createNewLink !== '' && this.createNewLink !== undefined) {
      this.router.navigate([this.createNewLink]);
      return;
    }

    if (this.newRecordInDrawer === false) {
      this.newRecordClicked.emit();
    } else {
      RecordPageComponent.openRecordPage(this.drawerService, {
        drawerTitle: this.layoutService.translate(
          'Create a new ' + this.moduleStructure.module.Name.toLowerCase()
        ),
        moduleId: this.moduleId,
        inDrawer: true,
        recordId: '',
        recordModel: undefined,
        actionType: 'Add',
        parentComponent: this,
        inputValues: this.inputValuesForNew,
      });

      this.newRecDrawerVisible = true;
    }
  }

  choose() {
    if (this.selectedRecords.length > 0) {
      this.newObjectCreated.emit(this.selectedRecords.join(','));
      this.backButtonClicked.emit();
    } else {
      this.newObjectCreated.emit(this.selectedRecords[0]);
      this.backButtonClicked.emit();
    }
  }

  linkedObjectSubmitted(event) {
    if (event !== '') {
      this.selectedRecords = [event];
      this.selectionChanged.emit(this.selectedRecords);
    }

    this.newObjectCreated.emit(event);

    this.reloadTheRecords();
  }

  submitCreateLinkedObject(button: NzButtonComponent) {
    this.submitCreateButtonEmitter.emit(button);
  }

  isNumber(val): boolean {
    return typeof val === 'number';
  }

  @ViewChild(RecordsListTableComponent)
  recordsTable!: RecordsListTableComponent;
  visible = false;
  selectedItemsForBulkEdit: any[] = [];
  open(): void {
    this.recordsTable.openDrawer();
  }

  close(): void {
    this.recordsTable.closeDrawer();
    // this.visible = false;
  }
  onSelectedItemsChange(selectedItems: any[]) {
    this.selectedItemsForBulkEdit = selectedItems;
  }
  handleSubmitFromTable(): void {
    this.reloadTheRecords(false, true);
  }
}
